import App from "../../core/src/App";
import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import BetModel from "../../core/src/model/BetModel";
import ErrorModel from "../../core/src/model/ErrorModel";
import SpinModel from "../../core/src/model/SpinModel";
import { State } from "../../core/src/states/State";
import PromotionalFreeGamesModel from "../model/PromotionalFreeGamesModel";

export default class VendorSpinGetResultState extends State {
    protected _canExit: boolean;

    enter() {
        this._canExit = false;
        super.enter();
        this.sendRequest();
    }

    sendRequest() {
        if (!SpinModel.isInFreespins() && !SpinModel.isInRespins()) {
            SpinModel.spinFinished = false;
            this.exit();
        } else {
            CommandManager.execute(
                Commands.UPDATE_FREE_SPINS,
                SpinModel.freespinsNum.toString()
            );
            App.timeline.call(
                this.onResponse,
                [],
                this,
                App.timeline.time + 0.5
            );
        }
    }

    protected onResponse(data?: any) {
        this._canExit = true;

        SpinModel.update(data);
        PromotionalFreeGamesModel.update(data);
        ErrorModel.update(data);
        BetModel.update(data);

        this.exit();
    }
}
